module.exports = __webpack_public_path__ + "static/media/background1.748cb095.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/bg/background1.jpg
// module id = 406
// module chunks = 0